import MarkDownRenderer from '../../../../../commonComponents/MarkDownRender/MarkDownRender.Component';

export const markdownContent = `
## **Response Panel**

The response panel displays gRPC responses in real time.

### 📥 Response Types
- Unary response
- Server streaming responses
- Bidirectional streaming messages

Each response includes:
- Response body
- Metadata
- Trailers (if available)

### 🔄 Multiple Responses
For streaming calls, responses are grouped as:
- Response 1
- Response 2
- Response 3…

This makes it easy to debug streaming behavior visually.
`;

const GRPCResponsePanel = () => {
    return (
        <MarkDownRenderer
            title="Responses"
            markDownText={markdownContent}
        />
    );
};

export default GRPCResponsePanel;
